import { useNavigate } from 'react-router';
import { TextUI } from './Text';
import { onClickHandler } from './utilities/click_handler';
import colors from './colors';

export type TextLinkProps = {
  children: string | React.ReactNode
  path: string
  color?: keyof typeof colors
};

export const TextLinkUI: React.FC<TextLinkProps> = ({ children, path, color }) => {
  const navigate = useNavigate();
  return (
    <a href={path} onClick={onClickHandler(() => navigate(path))} style={{ textDecoration: 'none' }}>
      <TextUI color={color || 'grey'} weight="bold">
        {children}
      </TextUI>
    </a>
  );
};
